module.exports = __webpack_public_path__ + "static/gradeguide-4b008b26ec494cf0a38d3181956009a9.png";